import {Directive, ElementRef, OnDestroy, OnInit} from '@angular/core';
import {MainHeaderService} from './main-header.service';

@Directive({
    selector: '[dbMainHeaderContent]',
    standalone: false
})
export class MainHeaderContentDirective implements OnInit, OnDestroy {

  constructor(
    private _element: ElementRef,
    private _mainHeaderService: MainHeaderService
  ) {}

  ngOnInit() {
    this._mainHeaderService.setContentElement(this._element);
  }

  ngOnDestroy() {
    this._mainHeaderService.unsetContentElement();
  }

}
